// Bootstrap vocabulary for full imports; runtime choices come from the API.
export const TOPIC_CLASSIFICATION_SEEDS = {
  domain: [
    'Allergische / asthmatische und andere Atemwegserkrankungen (B)',
    'Alter (B)',
    'Angeborene / erworbene Fehlbildungen und Behinderungen (B)',
    'Arbeit / Erwerbstätigkeit (z.B. auch beschützte Werkstätten) (B)',
    'Armut / soziale Notlagen (B)',
    'Bereichsspektrum im Gebiet Bildung / Ausbildung (B)',
    'Bereichsspektrum im Gebiet Erkrankungen und Behinderungen (B)',
    'Bereichsspektrum im Gebiet Freizeit / Geselligkeit (B)',
    'Bereichsspektrum im Gebiet Gemeinwesen (B)',
    'Bereichsspektrum im Gebiet Lebensformen / Zusammenleben (B)',
    'Bereichsspektrum im Gebiet Lebenskrisen (B)',
    'Bereichsspektrum im Gebiet Sucht / Abhängigkeit (B)',
    'Bereichsspektrum im Gebiet Umwelt (B)',
    'Bereichsspektrum im Gebiet politische Rechte (B)',
    'Bereichsspektrum im Gebiet Ökonomie (B)',
    'Bereichsübergreifend (B)',
    'Beziehungen / Partnerschaften (B)',
    'Bürgerbeteiligung (B)',
    'Bürgerrechte / Menschenrechte (B)',
    'Chronische Schmerzen (B)',
    'Ehe / Familie (B)',
    'Elternschaft / Erziehung (B)',
    'Endokrine, Ernährungs- und Stoffwechselkrankheiten (B)',
    'Erkrankungen der Verdauungsorgane und des Harntraktes (B)',
    'Ernährung / Nahrung (B)',
    'Erwachsenenbildung (B)',
    'Gemeinsame Aktivitäten und Unternehmungen (z.B. Reisen) (B)',
    'Genossenschaften / alternative Ökonomie (z.B. Tauschringe) (B)',
    'Gewaltformen (B)',
    'Hauterkrankungen (B)',
    'Herz-Kreislauf-Erkrankungen (B)',
    'Hirnschädigungen (B)',
    'Infektionskrankheiten (B)',
    'Kindheit / Jugend (B)',
    'Krankheiten der Sinnesorgane / Hör-, Seh- und Sprachbehinderungen (B)',
    'Krankheiten des Blutes, des Immunsystems / Immundefekte (B)',
    'Krankheiten des Nervensystems (B)',
    'Krankheiten des Skeletts, der Gelenke, der Muskeln und des Bindegewebes (B)',
    'Lebensprobleme (B)',
    'Lebererkrankungen (B)',
    'Lehre / Studium (B)',
    'Naturschutz / Tierschutz (B)',
    'Nichtstoffgebundene Süchte (B)',
    'Organtransplantationen (B)',
    'Psychische Erkrankungen (B)',
    'Religion / Glauben / Weltanschauung (B)',
    'Schule (B)',
    'Seelisches / körperliches Wohlbefinden (B)',
    'Selbstorganisierte soziale Hilfen / freiwilliges soziales Engagement (B)',
    'Sexualität / Geschlecht (B)',
    'Soziale Sicherung / Teilhabe (B)',
    'Sport / Spiel / Bewegung (B)',
    'Stoffgebundene Süchte (B)',
    'Technikfolgen / Werkstoffgefährungen (B)',
    'Tod / Sterben / Verlustsituationen (B)',
    'Tumorerkrankungen (B)',
    'Umwelterkrankungen (B)',
    'Unfall (B)',
    'Verbraucherschutz / Patientenschutz / Patientenbeteiligung (B)',
    'Verkehr / Mobilität (B)',
    'Verschiedene Erkrankungen / Behinderungen - Mehrfacherkrankungen / Mehrfachbehinderungen (B)',
    'Wohnen (B)',
    'Zuwanderung (B)',
  ],
  icdArea: [
    'Angeborene Fehlbildungen, Deformitäten und Chromosomenanomalien',
    'Bestimmte Zustände, die ihren Ursprung in der Perinatalperiode haben',
    'Bestimmte infektiöse und parasitäre Krankheiten',
    'Endokrine, Ernährungs- und Stoffwechselkrankheiten',
    'Faktoren, die den Gesundheitszustand beeinflussen und zur Inanspruchnahme des Gesundheitswesens führen',
    'Humangenetik',
    'Krankheiten der Haut und der Unterhaut',
    'Krankheiten des Atmungssystems',
    'Krankheiten des Auges und der Augenanhangsgebilde',
    'Krankheiten des Blutes und der blutbildenden Organe sowie bestimmte Störungen mit Beteiligung des Immunsystems',
    'Krankheiten des Kreislaufsystems',
    'Krankheiten des Muskel-Skelett-Systems und des Bindegewebes',
    'Krankheiten des Nervensystems',
    'Krankheiten des Ohres und des Warzenfortsatzes',
    'Krankheiten des Urogenitalsystems',
    'Krankheiten des Verdauungssystems',
    'Krankheiten sonstiger endokriner Drüsen',
    'Neubildungen',
    'Psychische und Verhaltensstörungen',
    'Schwangerschaft, Geburt und Wochenbett',
    'Sonstige Formen der Herzkrankheit',
    'Sonstige Komplikationen nach Impfung [Immunisierung], anderenorts nicht klassifiziert',
    'Sonstige und nicht näher bezeichnete Schäden durch äußere Ursachen',
    'Symptome und abnorme klinische und Laborbefunde, die anderenorts nicht klassifiziert sind',
    'Symptome, die das Erkennungs- und Wahrnehmungsvermögen, die Stimmung und das Verhalten betreffen',
    'Systemkrankheiten des Bindegewebes',
    'Verletzungen, Vergiftungen und bestimmte andere Folgen äußerer Ursachen',
  ],
  icdGroup: [
    'Abnorme Befunde ohne Vorliegen einer Diagnose bei bildgebender Diagnostik und Funktionspruefung',
    'Abnorme Gewohnheit und Störung der Impulskontrolle, nicht näher bezeichnet',
    'Adipositas und sonstige Überernährung',
    'Affektionen der Aderhaut und der Netzhaut',
    'Affektionen der Augenmuskeln, Störungen der Blickbewegungen sowie Akkommodationsstörungen und Refraktionsfehler',
    'Affektionen der Linse',
    'Affektionen der Sklera, der Hornhaut, der Iris und des Ziliarkörpers',
    'Affektionen des Augenlides, des Tränenapparates und der Orbita',
    'Affektionen des N. opticus und der Sehbahn',
    'Affektive Störungen',
    'Alimentäre Anämien',
    'Allgemeinsymptome',
    'Angeborene Fehlbildungen der Genitalorgane',
    'Angeborene Fehlbildungen des Atmungssystems',
    'Angeborene Fehlbildungen des Auges, des Ohres, des Gesichtes und des Halses',
    'Angeborene Fehlbildungen des Harnsystems',
    'Angeborene Fehlbildungen des Kreislaufsystems',
    'Angeborene Fehlbildungen des Nervensystems',
    'Angeborene Fehlbildungen und Deformitäten des Muskel-Skelett-Systems',
    'Angeborene Luxation des Hüftgelenkes, nicht näher bezeichnet',
    'Aplastische und sonstige Anämien',
    'Arthrogryposis multiplex congenita',
    'Arthropathien',
    'Bestimmte Störungen mit Beteiligung des Immunsystems',
    'Bestimmte bakterielle Zoonosen',
    'Betreuung der Mutter im Hinblick auf den Feten und die Amnionhöhle sowie mögliche Entbindungskomplikationen',
    'Bullöse Dermatosen',
    'Bösartige Neubildungen',
    'Chondropathien',
    'Chromosomenanomalien, anderenorts nicht klassifiziert',
    'Chronische Krankheiten der unteren Atemwege',
    'Chronische rheumatische Herzkrankheiten',
    'Demyelinisierende Krankheiten des Zentralnervensystems',
    'Dermatitis und Ekzem',
    'Diabetes mellitus',
    'Entbindung',
    'Entwicklungsstörungen',
    'Entzündliche Krankheiten des Zentralnervensystems',
    'Episodische und paroxysmale Krankheiten des Nervensystems',
    'Extrapyramidale Krankheiten und Bewegungsstörungen',
    'Gilbert-Meulengracht-Syndrom',
    'Glaukom',
    'Glomerulaere Krankheiten',
    'Gutartige Neubildungen',
    'HIV-Krankheiten [Humane Immundefizienz-Viruskrankheit]',
    'Harnorgane',
    'Helminthosen',
    'Hypertonie (Hochdruckkrankheit)',
    'Hämolytische Anämien',
    'In-situ-Neubildungen',
    'Infektionen der Haut und der Unterhaut',
    'Infektionen, die für die Perinatalperiode spezifisch sind',
    'Infektionen, die vorwiegend durch Geschlechtsverkehr übertragen werden',
    'Intelligenzminderung',
    'Ischämische Herzkrankheiten',
    'Koagulopathien, Purpura und sonstige hämorrhagische Diathesen',
    'Komplikationen bei chirurgischen Eingriffen und medizinischer Behandlung, anderenorts nicht klassifiziert',
    'Krankheiten der Arterien, Arteriolen und Kapillaren',
    'Krankheiten der Gallenblase, der Gallenwege und des Pankreas',
    'Krankheiten der Haut und der Unterhaut durch Strahleneinwirkung',
    'Krankheiten der Hautanhangsgebilde',
    'Krankheiten der Leber',
    'Krankheiten der Mamma',
    'Krankheiten der Mundhöhle, der Speicheldrüsen und der Kiefer',
    'Krankheiten der Schilddrüse',
    'Krankheiten der Synovialis und der Sehnen',
    'Krankheiten der Venen, der Lymphgefäße und der Lymphknoten, anderenorts nicht klassifiziert',
    'Krankheiten der Weichteilgewebe',
    'Krankheiten der Wirbelsäule und des Rückens',
    'Krankheiten der männlichen Genitalorgane',
    'Krankheiten des Darmes',
    'Krankheiten des Innenohres',
    'Krankheiten des Nervensystems',
    'Krankheiten des Ösophagus, des Magens und des Duodenums',
    'Krankheiten im Bereich der neuromuskulären Synapse und des Muskels',
    'Krankheiten sonstiger endokriner Drüsen',
    'Krankheiten von Nerven, Nervenwurzeln und Nervenplexus',
    'Lippen-, Kiefer- und Gaumenspalte',
    'Lungenkrankheiten durch exogene Substanzen',
    'Magenerkrankungen',
    'Melanom und sonstige bösartige Neubildungen der Haut',
    'Mykosen',
    'Neubildungen unsicheren oder unbekannten Verhaltens [siehe Hinweis am Anfang der Krankheitsgruppe D37-D48]',
    'Neurotische, Belastungs- und somatoforme Störungen',
    'Nicht infektiöse Enteritis und Kolitis',
    'Nichtentzündliche Krankheiten des weiblichen Genitaltraktes',
    'Niereninsuffizienz',
    'Organische, einschließlich symptomatischer psychischer Störungen',
    'Osteopathien und Chondropathien',
    'Papulosquamöse Hautkrankheiten',
    'Personen mit potentiellen Gesundheitsrisiken aufgrund der Familien- oder Eigenanamnese und bestimmte Zustände, die den Gesundheitszustand beeinflussen',
    'Personen mit potentiellen Gesundheitsrisiken hinsichtlich übertragbarer Krankheiten',
    'Personen, die das Gesundheitswesen aus sonstigen Gründen in Anspruch nehmen',
    'Personen, die das Gesundheitswesen im Zusammenhang mit Problemen der Reproduktion in Anspruch nehmen',
    'Personen, die das Gesundheitswesen zum Zwecke spezifischer Maßnahmen und zur medizinischen Betreuung in Anspruch nehmen',
    'Persönlichkeits- und Verhaltensstörungen',
    'Phobien, spezifische isolierte Polyneuropathien und sonstige Krankheiten des peripheren Nervensystems',
    'Psychische und Verhaltensstörungen durch psychotrope Substanzen',
    'Pulmonale Herzkrankheit und Krankheiten des Lungenkreislaufes',
    'Schizophrenie, schizotype und wahnhafte Störungen',
    'Schwangerschaft mit abortivem Ausgang',
    'Sehstörungen und Blindheit',
    'Sicca-Syndrom [Sjögren-Syndrom]',
    'Sonstige Affektionen des Auges und der Augenanhangsgebilde',
    'Sonstige Amnesie',
    'Sonstige Formen der Herzkrankheit',
    'Sonstige Krankheiten der Atmungsorgane, die hauptsächlich das Interstitium betreffen',
    'Sonstige Krankheiten der Haut und der Unterhaut',
    'Sonstige Krankheiten der Niere und des Ureters',
    'Sonstige Krankheiten der Wirbelsäule und des Rückens',
    'Sonstige Krankheiten der oberen Atemwege',
    'Sonstige Krankheiten des Atmungssystems',
    'Sonstige Krankheiten des Blutes und der blutbildenden Organe',
    'Sonstige Krankheiten des Darmes',
    'Sonstige Krankheiten des Harnsystems',
    'Sonstige Krankheiten des Nervensystems',
    'Sonstige Krankheiten des Ohres',
    'Sonstige Krankheiten des Verdauungssystems',
    'Sonstige Krankheiten des Weichteilgewebes',
    'Sonstige Krankheiten endokriner Drüsen',
    'Sonstige Nahrungsmittelunverträglichkeit, anderenorts nicht klassifiziert',
    'Sonstige Osteopathien',
    'Sonstige Spirochätenkrankheiten',
    'Sonstige Störungen der Blutglukose-Regulation und der inneren Sekretion der Pankreas',
    'Sonstige Störungen, die ihren Ursprung in der Perinatalperiode haben',
    'Sonstige Viruskrankheiten',
    'Sonstige alimentäre Mangelzustände',
    'Sonstige angeborene Fehlbildungen des Verdauungssystems',
    'Sonstige angeborene Fehlbildungen',
    'Sonstige bakterielle Krankheiten',
    'Sonstige degenerative Krankheiten des Nervensystems',
    'Sonstige und nicht näher bezeichnete Krankheiten des Kreislaufsystems',
    'Sonstige und nicht näher bezeichnete Schäden durch äußere Ursachen',
    'Stoffwechselstörungen',
    'Störungen im Zusammenhang mit der Schwangerschaftsdauer und dem fetalen Wachstum',
    'Symptome die das Verdauungssystem und das Abdomen betreffen',
    'Symptome, die das Atmungs- und das Kreislaufsystem betreffen',
    'Symptome, die das Erkennungs- und Wahrnehmungsvermögen, die Stimmung und das Verhalten betreffen',
    'Symptome, die das Harnsystem betreffen',
    'Symptome, die das Kreislaufsystem und das Atmungssystem betreffen',
    'Symptome, die das Nervensystem und das Muskel-Skelett-System betreffen',
    'Symptome, die die Sprache und die Stimme betreffen',
    'Syndrom polyzystischer Ovarien',
    'Systematrophien, die vorwiegend das zentrale Nervensystem betreffen',
    'Systemkrankheiten des Bindegewebes',
    'Toxische Wirkungen von vorwiegend nicht medizinisch verwendeten Substanzen',
    'Tuberkulose',
    'Tubulointerstitielle Nierenkrankheiten',
    'Ungenau bezeichnete und unbekannte Todesursachen',
    'Unterfunktion und andere Störungen der Hypophyse',
    'Urtikaria und Erythem',
    'Verbrennungen oder Verätzungen',
    'Verdauungsorgane',
    'Verhaltens- und emotionale Störungen mit Beginn in der Kindheit und Jugend',
    'Verhaltensauffälligkeiten mit körperlichen Störungen und Faktoren',
    'Verletzungen des Kopfes',
    'Verletzungen nicht näher bezeichneter Teile des Rumpfes, der Extremitäten oder anderer Körperregionen',
    'Virushepatitis',
    'Virusinfektionen des Zentralnervensystems',
    'Virusinfektionen, die durch Haut- und Schleimhautläsionen gekennzeichnet sind',
    'Vorhandensein von kardialem oder vaskulärem Implantat oder Transplantat, nicht näher bezeichnet',
    'Zerebrale Lähmung und sonstige Lähmungssyndrome',
    'Zerebrovaskuläre Krankheiten',
    'Ödeme, Proteinurie und Hypertonie während der Schwangerschaft, der Geburt und des Wochenbettes',
  ],
} as const;
